export const propFaqBooking = {
  faqEditor: {
    empty: "Aucune question pour l'instant. Ajoutez la première pour que l'agent sache y répondre.",
    learnedTooltip: "Réponse ajoutée via l'auto-apprentissage de l'hôte",
    learnedBadge: "Appris",
    removeAttachment: "Supprimer la pièce jointe",
    uploading: "Téléversement…",
    attach: "Joindre",
    deleteTooltip: "Supprimer",
    addQuestion: "Ajouter une question",
    qPlaceholder: "Question · ex. Y a-t-il un parking ?",
    aPlaceholder: "Réponse · ex. Oui, gratuit juste devant.",
    errors: {
      fillBeforeAttach: "Saisissez la question et la réponse avant de joindre des fichiers.",
      saveBeforeAttach: "Enregistrez d'abord pour joindre des fichiers.",
      uploadFailed: "Impossible de téléverser le fichier.",
      deleteFailed: "Impossible de supprimer le fichier.",
    },
  },
  faqSuggestions: {
    title: "Suggestions à apprendre",
    intro: "L'agent n'a pas pu répondre à ces questions et vous avez répondu au voyageur. Vérifiez-les, modifiez-les si nécessaire et enregistrez-les pour que l'agent puisse y répondre de lui-même désormais.",
    askedLabel: "Le voyageur a demandé",
    questionLabel: "Question",
    questionPlaceholder: "Comment formuleriez-vous la question ?",
    answerLabel: "Réponse de l'agent",
    answerPlaceholder: "Réponse que l'agent donnera",
    applyToOthers: "Appliquer aussi aux autres unités de l'annonce :",
    dismiss: "Ignorer",
    saveAsAnswer: "Enregistrer comme réponse",
    errors: {
      saveFailed: "Impossible d'enregistrer.",
      dismissFailed: "Impossible d'ignorer.",
    },
  },
  sourceNote: {
    title: "Ordre de priorité des réponses de l'agent",
    infoAria: "Voir l'ordre de priorité des sources de l'agent",
    lead: "Lorsque deux sources indiquent quelque chose de différent sur un même détail, l'agent suit cet ordre :",
    faqPre: "Les FAQ ",
    faqStrong: "par unité individuelle",
    faqTag: "l'emportent",
    configMain: "Paramètres du logement",
    configMuted: "· horaires, capacité, services",
    kb: "Base de connaissances",
  },
  bookingLinks: {
    title: "Comment le voyageur réserve",
    subPre: "L'agent envoie votre lien ",
    subStrong: "Réservations Directes",
    subPost: " et le voyageur réserve sur le web.",
    step1Pre: "S'il mentionne un ",
    step1Strong: "logement précis",
    step1Post: ", l'agent envoie son lien direct.",
    step2Pre: "S'il y en a ",
    step2Strong1: "plusieurs dans cette zone",
    step2Mid: ", il ",
    step2Strong2: "liste chacun avec son lien",
    step2Post: " ainsi que le lien global.",
    step3Pre: "S'il ne connaît pas la zone, il ",
    step3Strong: "suggère les zones disponibles",
    step3Post: " et demande où le voyageur souhaite séjourner.",
    globalLinkLabel: "Lien global (tous les emplacements)",
    copy: "Copier",
    copied: "Copié",
    noIdNote: "Le lien de réservation sera généré une fois que l'identifiant sera configuré sur votre compte.",
    toastCopied: "Lien copié",
    toastCopyFailed: "Impossible de copier",
  },
  bookingConfirm: {
    title: "Notifier une nouvelle réservation",
    subPre: "Lorsqu'une réservation est confirmée, nous notifions automatiquement le voyageur ",
    subStrong: "sur WhatsApp",
    subPost: " avec les détails de son séjour.",
    toggleLabel: "Envoyer la confirmation sur WhatsApp",
    toggleHint: "Si vous désactivez ceci, cette notification ne sera pas envoyée au voyageur. Si la réservation provient d'une OTA, c'est l'OTA qui le notifiera.",
    stateOn: "Oui, l'envoyer",
    stateOff: "Ne pas envoyer",
    notEditablePre: "Pour l'instant, le contenu de ce message ",
    notEditableStrong: "ne peut pas être modifié",
    notEditablePost: ". Nous vous montrons un aperçu de ce que le voyageur reçoit.",
    previewTag: "Aperçu · ce que le voyageur voit",
    online: "en ligne",
    today: "Aujourd'hui",
    previewHint: "Se met à jour avec votre configuration",
    defaultListingName: "Logement",
    toastEnabled: "Notification de réservation activée",
    toastDisabled: "Notification de réservation désactivée",
    toastSaveFailed: "Impossible d'enregistrer la modification",
    previewGuest: "Laura García",
    previewBody: "Bonjour *{guest}* 👋\n\nVotre réservation chez *{name}* est confirmée ✅\n\nCode de réservation : *6233Q1VC5*\nDates : *05/06/2026* – *07/06/2026* 📅\n\nVia ce WhatsApp, vous pouvez demander votre lien de check-in en ligne et recevoir également les instructions d'arrivée.\nSi vous avez besoin d'aide avant ou pendant votre séjour, écrivez-nous ici 💬",
    previewCta: "🇪🇸 Pour continuer le check-in, appuyez sur le bouton *Ok* ou tapez *Ok*.",
  },
};
